import useService from '@modules/ServiceModule/useService';

const QueuesPanel = () => {
  const { queues } = useService();
  return (
    <div>
      <pre>{JSON.stringify(queues, undefined, 2)}</pre>
    </div>
  );
};

export default QueuesPanel;
